<template>
    <c-dialog ref="dialog" mode="slide" width="60vw" enable-flex mask-close :button="false">
        <c-table ref="productList">
            <c-table-column
                    label="充值申请单"
                    name="record_number"
                    width="120"
            >
            </c-table-column>

            <c-table-column
                    name="recharge_money"
                    label="充值金额"
                    width="80"
            >
                <template #default="{data}">
                    <span style="color: black">￥{{data.recharge_money||0}}</span>
                </template>
            </c-table-column>

            <c-table-column
                    name="points_amount"
                    label="预计到账积分"
                    width="80"
                    v-if="withdraw_account_type == 4 || withdraw_account_type == 5"
            >
                <template #default="{data}">
                    <span style="color: green">{{data.points_amount||0}}</span>
                </template>
            </c-table-column>

            <c-table-column
                    label="审批状态"
                    name="audit_state"
                    width="90"
            >
                <template #default="{data}">
                    <c-state async dict="AUDIT_STATE" :value="data.audit_state"></c-state>
                </template>
            </c-table-column>

            <c-table-column
                    label="审批时间"
                    name="audit_date"
                    width="140"
            >
                <template #default="{data}">
                    <span v-if="data.audit_state!=1 && data.audit_date">{{data.audit_date}}</span>
                    <span v-else>--</span>
                </template>
            </c-table-column>

            <c-table-column
                    label="审批备注"
                    name="audit_date"
                    width="200"
            >
                <template #default="{data}">
                    <span v-if="data.audit_state!=1 && data.audit_remark">{{data.audit_remark}}</span>
                    <span v-else>--</span>
                </template>
            </c-table-column>

            <c-table-column
                    name="create_user_realname"
                    label="申请人"
                    width="130"
            >
            </c-table-column>

            <c-table-column
                    name="create_date"
                    label="申请时间"
                    width="130"
            >
            </c-table-column>
        </c-table>
    </c-dialog>
</template>

<script>

export default {
    name: 'rechargeApplyList',

    components: {
    },

    props: {
        withdraw_account_type: [String, Number],//提现账户类型：1=通联余额账户；2=三方余额
        withdraw_user_type: [String, Number]// 提现申请人类型：1=商家主账号 2=商家子账号 3=平台会员
    },

    data() {
        return {
            detailData: {},
            check_order_id:0,                  //核销单ID
            check_confirm_id:0,               //核销确认单ID
        }
    },

    computed: {
    },

    methods: {
        /********搜索************/
        searchHandle(data){
            if (!data){
                data = {};
            }
            data.account_type = this.withdraw_account_type;
            this.$refs.productList.load({
                url: '/account/recharge/list',
                data
            });
        },
        open() {
            this.searchHandle();
            var name = '';
            if (this.withdraw_account_type==3){
                name = '【保证金账户】';
            }else if (this.withdraw_account_type==4){
                name = '【渠道同售积分】';
            }else if (this.withdraw_account_type==5){
                name = '【IMEI查询积分】';
            }
            this.$refs.dialog.open({
                title: name+'充值记录'
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
    .logs-list {
        padding: 10px 10px;

        li {
            padding: 4px 0;
            line-height: 16px;
            font-size: 13px;
            color: #666;
        }
    }
</style>